import type { Date as GraphQLDate } from '~/graphql/types';

export type AppointmentDateCheck = {
  isToday: boolean;
  isInFuture: boolean;
  isInPast: boolean;
};

/**
 * Analyzes appointment date relative to today
 * Normalizes both dates to start of day to avoid timezone issues
 */
export const analyzeAppointmentDate = (
  appointmentDate: GraphQLDate,
): AppointmentDateCheck => {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Normalize to start of day

  const appointmentDay = new Date(appointmentDate.d);
  appointmentDay.setHours(0, 0, 0, 0); // Normalize to start of day

  const todayTime = today.getTime();
  const appointmentTime = appointmentDay.getTime();

  return {
    isToday: appointmentTime === todayTime,
    isInFuture: appointmentTime >= todayTime,
    isInPast: appointmentTime < todayTime,
  };
};

export const isAppointmentInPast = (appointmentDate: GraphQLDate): boolean =>
  analyzeAppointmentDate(appointmentDate).isInPast;

export const isAppointmentToday = (appointmentDate: GraphQLDate): boolean =>
  analyzeAppointmentDate(appointmentDate).isToday;

export const isAppointmentInFuture = (appointmentDate: GraphQLDate): boolean =>
  analyzeAppointmentDate(appointmentDate).isInFuture;
